export const typographyUtilities = {
  '.neue-montreal-display-1': {
    '@apply font-sans font-book leading-110% text-7xl md:text-10xl xl:text-12xl -tracking-1% md:-tracking-1.5% xl:-tracking-2%':
      {},
  },
  '.neue-montreal-display-2': {
    '@apply font-sans font-book leading-110% text-5xl md:text-7xl xl:text-9xl 3xl:text-11xl tracking-0.5% md:tracking-normal xl:-tracking-0.5% 3xl:-tracking-1%':
      {},
  },
  '.neue-montreal-heading-1': {
    '@apply font-sans font-regular leading-110% text-2xl md:text-4xl xl:text-6xl 3xl:text-8xl tracking-0.5% md:tracking-normal xl:-tracking-0.5% 3xl:-tracking-1% [&_sup]:-top-[25%]':
      {},
  },
  '.neue-montreal-heading-2': {
    '@apply font-sans font-regular leading-120% text-lg md:text-xl xl:text-2xl 3xl:text-3xl tracking-1% md:-tracking-0.5% xl:tracking-normal 3xl:-tracking-0.5%':
      {},
  },
  '.neue-montreal-heading-3': {
    '@apply font-sans font-medium leading-135% text-base md:text-md 3xl:text-lg tracking-2%':
      {},
  },
  '.neue-montreal-body-1': {
    '@apply font-sans font-regular leading-135% text-lg md:text-xl xl:text-2xl 3xl:text-3xl tracking-2% md:tracking-1.5% xl:tracking-1% 3xl:tracking-0.5%':
      {},
  },
  '.neue-montreal-body-2': {
    '@apply font-sans font-regular leading-135% text-base md:text-md 3xl:text-lg tracking-2%':
      {},
  },
  '.neue-montreal-body-3': {
    '@apply font-sans font-regular leading-140% text-sm tracking-3%': {},
  },
  '.neue-montreal-ui-1': {
    '@apply font-sans font-medium leading-none text-base tracking-2%': {},
  },

  '.io-display-1': {
    '@apply font-io font-book leading-110% text-7xl md:text-10xl xl:text-12xl -tracking-1% md:-tracking-1.5% xl:-tracking-2%':
      {},
  },
  '.io-display-2': {
    '@apply font-io font-book leading-110% text-5xl md:text-7xl xl:text-9xl 3xl:text-11xl tracking-0.5% md:tracking-normal xl:-tracking-0.5% 3xl:-tracking-1%':
      {},
  },
  '.io-heading-1': {
    '@apply font-io font-regular leading-110% text-2xl md:text-4xl xl:text-6xl 3xl:text-8xl tracking-0.5% md:tracking-normal xl:-tracking-0.5% 3xl:-tracking-1%':
      {},
  },
  '.io-heading-2': {
    '@apply font-io font-regular leading-120% text-lg md:text-xl xl:text-2xl 3xl:text-3xl tracking-1% md:-tracking-0.5% xl:tracking-normal 3xl:-tracking-0.5%':
      {},
  },
  '.io-heading-3': {
    '@apply font-io font-medium leading-135% text-base md:text-md 3xl:text-lg tracking-2%':
      {},
  },
  '.io-body-1': {
    '@apply font-io font-regular leading-135% text-lg md:text-xl xl:text-2xl 3xl:text-3xl tracking-2% md:tracking-1.5% xl:tracking-1% 3xl:tracking-0.5%':
      {},
  },
  '.io-body-2': {
    '@apply font-io font-regular leading-135% text-base md:text-md 3xl:text-lg tracking-2%':
      {},
  },
  '.io-body-3': {
    '@apply font-io font-regular leading-140% text-sm tracking-3%': {},
  },
  '.io-ui-1': {
    '@apply font-io font-medium leading-none text-base tracking-2%': {},
  },
}
